import LoginStreakRewardsSettings from "./LoginStreakSettings";
import RegistrationRewardsSettings from "./RegistrationRewardsSettings";
import FreePackRewardsSettings from "./FreePackRewardsSettings";
import MarketplaceFeesSettings from "./MarketplaceFeesSettings";
import BinCardSettings from "./BinCardSettings";
import LeaderboardSettings from "./LeaderboardSettings";
import AppVersionSettings from "./AppVersionSettings";
import VersusSettings from "./VersusSettings";
import MarketplacePackSettings from "./MarketplacePackSettings";
import ShowSeasonEndAlertSettings from "./ShowSeasonEndAlertSettings";
import ShowProfileCompletionOverlaySettings from "./ShowProfileCompletionOverlaySettings";
import { Typography } from "@mui/material";

export default function SettingsRenderer({
  settingsType,
  rawData,
  handleToggleSeasonEndAlert,
  isSeasonEndAlertUpdating,
}) {
  switch (settingsType) {
    case 0:
      return <LoginStreakRewardsSettings rawData={rawData} />;
    case 1:
      return <RegistrationRewardsSettings rawData={rawData} />;
    case 2:
      return <FreePackRewardsSettings rawData={rawData} />;
    case 3:
      return <MarketplaceFeesSettings rawData={rawData} />;
    case 4:
      return <BinCardSettings rawData={rawData} />;
    case 5:
      return <LeaderboardSettings rawData={rawData} />;
    case 6:
      return <AppVersionSettings rawData={rawData} />;
    case 7:
      return <VersusSettings rawData={rawData} />;
    case 8:
      return <MarketplacePackSettings rawData={rawData} />;
    case 9:
      return (
        <ShowSeasonEndAlertSettings
          rawData={rawData}
          handleToggle={handleToggleSeasonEndAlert}
          isUpdating={isSeasonEndAlertUpdating}
        />
      );
    case 10:
      return <ShowProfileCompletionOverlaySettings rawData={rawData} />;
    default:
      return <Typography variant="body2">Unknown settings type</Typography>;
  }
}
